const accessKeysIT = {
    "view": {
        "title": "Chiavi di accesso",
        "form": {
            "label": {
                "accessKeyId": "ID Chiave di Accesso",
                "secretAccessKey": "Chiave di Accesso Segreta"
            },
            "button": {
                "hide": "Nascondi",
                "reveal": "Mostra"
            },
            "message": {
                "accessKeyIdCopied": "ID Chiave di Accesso copiato negli appunti!",
                "secretAccessKeyCopied": "Chiave di Accesso Segreta copiata negli appunti!"
            }
        },
        "uploadInstructions": {
            "title": "Istruzioni",
            "step1": {
                "title": "Passo 1 - Scarica lo strumento di caricamento",
                "description": "Scarica lo strumento <1>Cyberduck</1>."
            },
            "step2": {
                "title": "Passo 2 - Fai una copia del Foglio di Caricamento e salva il file Trigger",
                "descriptionPoint1": "Copia questo <1><strong>FOGLIO</strong></1> nel tuo GOOGLE DRIVE.",
                "descriptionPoint2": "Salva questo <1><strong>FILE TRIGGER</strong></1> sul tuo computer o su un archivio cloud."
            },
            "step3": {
                "title": "Passo 3 - Stabilire la connessione",
                "descriptionPoint1": "Apri lo strumento Cyberduck.",
                "descriptionPoint2": "Nell'angolo in basso a sinistra clicca sull'icona +. (Aggiungi nuovo segnalibro).",
                "descriptionPoint3": "Inserisci le seguenti credenziali:",
                "descriptionPoint4": "ID Chiave di Accesso: ",
                "descriptionPoint5": "Chiave di Accesso Segreta: ",
                "descriptionPoint6": "La tua Cartella S3: ",
                "descriptionPoint7": "Il tuo Percorso S3: ",
                "descriptionPoint8": "Segui questi passaggi:"
            },
            "step4": {
                "title": "Passo 4 - Compila i metadati",
                "description": "Compila i metadati secondo le istruzioni del nostro Centro Assistenza."
            },
            "step5": {
                "title": "Passo 5 - File e Generi",
                "descriptionPoint1": "Carica il tuo file <1>metadata.csv</1> e tutti i file audio <3>(.wav)</3> e <5>immagine (.jpg)</5>, <7> NON (.jpeg)</7>",
                "descriptionPoint2": "I file <strong>JPG</strong> devono essere <strong>3000x3000 px, dimensione massima del file 4MB</strong>",
                "descriptionPoint3": "I file audio devono essere solo <strong>wav, 16 bit, 44.1 khz</strong>",
                "descriptionPoint4": "I nomi dei file di root devono essere una sola parola",
                "descriptionPoint5": "<strong>IMPORTANTE:</strong> Fai attenzione ai <2><strong>Generi ML Dance</strong></2> e alla corrispondenza nei negozi come Beatport."
            },
            "step6": {
                "title": "Passo 6 - Carica Trigger",
                "description": "Dopo che tutti i file sono stati caricati, per favore carica questo file trigger vuoto <1>“last.zzz”</1>. Monitora la tua email per eventuali notifiche."
            },
            "step7": {
                "title": "Consiglio - Testa con noi prima di caricare",
                "description": "Sentiti libero di contattare il nostro team di supporto per qualsiasi domanda riguardante questo modo di creare rilasci. Questo è un processo molto semplice che si basa su tecnologie più robuste come AWS S3 e non si basa sulle tecnologie del browser. Tuttavia, richiede che i tuoi metadati siano accurati al 100%. Il team di Music Link può testare il caricamento di alcuni rilasci per te con i tuoi metadati per rilevare eventuali problemi."
            }
        }
    }
};

export default accessKeysIT;